import React from 'react';
import styled from 'styled-components';
import { PaddedContainer } from './styles';

const Container = styled(PaddedContainer)`
  padding-left: 0.2vw;
  padding-bottom: 30px;

  ${props => props.theme.isMobile && `
    width: 100%;
    margin: 0;
    background-color: ${props.theme.secondaryColorLight};
    padding: 0 20px;
  `};
`;

const Paragraph = styled.p`
  text-align: left;
  color: ${props => props.theme.secondaryColor};
  margin: 0;
  font: ${props => props.theme.fontWeightBold} 12px/110% ${props => props.theme.fontFamilyBody};
`;

function Disclaimer() {
  return (
    <Container>
      <Paragraph>
        Livewire gives readers access to information and educational content
        provided by financial services professionals and companies (”Livewire
        Contributors”). Livewire does not operate under an Australian financial
        services licence and relies on the exemption available under section
        911A(2)(eb) of the Corporations Act 2001 (Cth) in respect of any advice
        given. Any advice on this site is general in nature and does not take into
        consideration your objectives, financial situation or needs. Before making
        a decision please consider these and any relevant Product Disclosure
        Statement. Livewire has commercial relationships with some Livewire
        Contributors.
      </Paragraph>
    </Container>
  );
}

export default React.memo(Disclaimer);
